module.exports = __webpack_public_path__ + "static/media/img5.8cb465f8.png";